module.exports = __webpack_public_path__ + "img/appImage-signup-forms--3.a74a9b9d.svg";